import React from "react";
import { Link } from "react-router-dom";

export default function Gold({ level }) {
  return (
    <div className="card-level">
      <p>
        Nível <b>Ouro</b>
      </p>
      <img
        alt="Nível"
        src={`${process.env.REACT_APP_URL_ASSETS}/images/gold_horizontal.png`}
      />
      <ul className="advantages">
        <li>
          <b>Gratuito</b>
        </li>
        <li>Conta única</li>
        <li>Login sem senha</li>
        <li>Gerenciar uso de dados</li>
        <li>Prova de vida</li>
        <li>Verificação em duas etapas</li>
        <li>Compartilhar documentos</li>
        <li>Assinatura eletrônica</li>
        <li>Acesso a todos os serviços</li>
        <li>Nível máximo de segurança</li>
      </ul>
      {level < 3 ? (
        <Link className="action-primary" to="/quero-este-nivel?nivel=ouro">
          Aumentar nível
        </Link>
      ) : (
        <Link className="action-secondary" to="/quero-este-nivel?nivel=ouro">
          Ver nível
        </Link>
      )}
    </div>
  );
}
